import { Box, Card, Chip, Paper, Typography, styled } from '@mui/material';

export const PrintablePage = styled(Paper)(({ theme }) => ({
  //padding: theme.spacing(3),
  backgroundColor: '#ffffff',
  borderRadius: 0,
  marginBottom: theme.spacing(2),
  marginTop: theme.spacing(2),
  padding: 0,
  margin: 0,
  '@media print': {
    marginBottom: 0,
    pageBreakBefore: 'always',
    ':not(:last-child)': {
      pageBreakAfter: 'always',
    },
    pageBreakInside: 'avoid',
    backgroundColor: 'white',
    marginTop: 0,
    position: 'relative'
  },
  '@media screen': {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    ':first-of-type': {
      marginTop: theme.spacing(8),
    },
    // set a min height in pixels so the pages dont collapse
    minHeight: '11.69in',
    width: '8.27in',
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: theme.spacing(3),
  }
}));

export const VariantCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  border: '1px solid',
  borderColor: theme.palette.divider,
  transition: 'box-shadow 0.2s ease-in-out',
  '&:hover': {
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
  },
  '&.pathogenic': {
    borderLeft: `4px solid ${theme.palette.error.main}`,
  },
  '&.vus': {
    borderLeft: `4px solid ${theme.palette.warning.main}`,
  },
  '&.drug-response': {
    borderLeft: `4px solid ${theme.palette.info.main}`,
  },
}));



export const Label = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontWeight: 500,
  fontSize: '0.875rem',
}));

export const Value = styled(Typography)({
  fontSize: '1rem',
});


export const VariantSummary = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  marginBottom: theme.spacing(3),
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
}));

export const Legend = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',
  marginBottom: theme.spacing(3),
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
}));

export const LegendItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  fontSize: '0.875rem',
  color: theme.palette.text.secondary,
}));



export const ZygosityChip = styled(Chip)(({ theme }) => ({
  '&.HOMOZYGOUS_ALT': {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.dark,
  },
  '&.HETEROZYGOUS': {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.dark,
  },
  '&.HETEROZYGOUS_ALT': {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.dark,
  },
  '&.HOMOZYGOUS_REF': {
    backgroundColor: theme.palette.success.light,
    color: theme.palette.success.dark,
  },
  '&.GENOTYPE_UNKNOWN': {
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.grey[700],
  },
}));

